import React, { useState } from 'react';
import { connect, history } from 'umi';

// import moment from 'moment';
// import { get, isEmpty, debounce } from 'lodash';
import classnames from 'classnames';
// import { trackSensors } from '@/utils/sensors';
import useGCPI18n from '@/hooks/useGCPI18n';
import { sanitizeParam } from '@/utils/sanitize';
import { onHistoryPush, goBack } from '@/utils/utils';
// import Header from '@/components/HeaderProduct';
import Header from '@/components/Header';
// import BasicBaseSpin from '@/components/BasicBaseSpin';
import checkFilled from '@/assets/images/circled-check-filled.svg';
import {
  createMemberRewardsDispatchProps,
  memberRewardsStateToProps,
  MemberRewardDialogs,
  MemberRewardsContent,
  RewardStateTabs,
  useMemberRewardActions,
} from './shared';
import styles from './index.less';

const MemberMyRewards = props => {
  const { saveMemData, qryUserRewardListDXP, claminMemRewardDXP, myMemRewardsList } = props;
  const GCPI18n = useGCPI18n();
  // const isDXP = false;

  const rawQuery = history.location.query || {};
  const membershipTypeCode = sanitizeParam(rawQuery.membershipTypeCode);
  const upgradeMethod = sanitizeParam(rawQuery.upgradeMethod);

  // const [form] = Form.useForm();
  // const { promotionId = '' } = history.location.query || JSON.parse(localStorage.getItem('promotionId'));

  // 空字符串代表all，A代表待领取UnClaimed，B代表已领取Claimed
  const [showClaimedModal, setShowClaimedModal] = useState(false);
  // const [loading, setLoading] = useState(false);
  const rewardActions = useMemberRewardActions({
    qryUserRewardListDXP,
    saveMemData,
    claminMemRewardDXP,
    membershipTypeCode,
    GCPI18n,
  });

  const handleGoDetail = item => {
    // 跳转到奖励详情页面
    const { keyId } = item;
    // const { keyId, rewardName = '', rewardMemName = '' } = item;
    // 神策埋点
    // trackSensors('PrizeDetails', {
    //   prize_id: keyId,
    //   prize_name: rewardMemName || rewardName,
    // });
    onHistoryPush('/memberShipCenterRewardDetail', {
      keyId,
    });
  };

  return (
    <div className={styles.page}>
      {/* <BasicBaseSpin spinning={loading}> */}
      <Header title={GCPI18n({ id: 'lb_medal_wall_title_mr' })} goBack={goBack} />
      <RewardStateTabs
        styles={styles}
        classnames={classnames}
        state={rewardActions.state}
        GCPI18n={GCPI18n}
        onChange={rewardActions.handleChangeState}
        hidden={upgradeMethod === '3'}
      />

      <MemberRewardsContent
        styles={styles}
        rewards={myMemRewardsList}
        GCPI18n={GCPI18n}
        onGoDetail={handleGoDetail}
        onClaim={rewardActions.handleClickClaimButton}
        showClaimedModal={showClaimedModal}
        claimedImage={checkFilled}
        onCloseClaimed={() => setShowClaimedModal(false)}
        showLuckyMessage
        extra={<MemberRewardDialogs {...rewardActions} />}
      />
      {/* </BasicBaseSpin> */}
    </div>
  );
};

export default connect(
  memberRewardsStateToProps,
  createMemberRewardsDispatchProps,
)(MemberMyRewards);
